import {
  addObj,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  getMyPage,
  confirmRemind,
} from '@/api/oilchangeplanserv'

export default {
  state: {
    state_OilChangePlan_AddObjResult: null,
    state_OilChangePlan_GetPageResult: null,
    state_OilChangePlan_GetDetailResult: null,
    state_OilChangePlan_ModifyObjResult: null,
    state_OilChangePlan_DeleteObjResult: null,
    state_OilChangePlan_GetMyPageResult: null,
    state_OilChangePlan_ConfirmRemindResult: null,
  },
  mutations: {
    SET_OILCHANGEPLAN_ADDOBJ_RESULT: (state, rst) => {
      state.state_OilChangePlan_AddObjResult = rst;
    },
    SET_OILCHANGEPLAN_GETPAGE_RESULT: (state, rst) => {
      state.state_OilChangePlan_GetPageResult = rst;
    },
    SET_OILCHANGEPLAN_GETDETAIL_RESULT: (state, rst) => {
      state.state_OilChangePlan_GetDetailResult = rst;
    },
    SET_OILCHANGEPLAN_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_OilChangePlan_ModifyObjResult = rst;
    },
    SET_OILCHANGEPLAN_DELETEOBJ_RESULT: (state, rst) => {
      state.state_OilChangePlan_DeleteObjResult = rst;
    },
    SET_OILCHANGEPLAN_GETMYPAGE_RESULT: (state, rst) => {
      state.state_OilChangePlan_GetMyPageResult = rst;
    },
    SET_OILCHANGEPLAN_CONFIRMREMIND_RESULT: (state, rst) => {
      state.state_OilChangePlan_ConfirmRemindResult = rst;
    },
  },
  actions: {
    OilChangePlanServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OILCHANGEPLAN_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OILCHANGEPLAN_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OilChangePlanServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OILCHANGEPLAN_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OILCHANGEPLAN_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OilChangePlanServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OILCHANGEPLAN_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OILCHANGEPLAN_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OilChangePlanServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OILCHANGEPLAN_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OILCHANGEPLAN_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OilChangePlanServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OILCHANGEPLAN_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OILCHANGEPLAN_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OilChangePlanServ_GetMyPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OILCHANGEPLAN_GETMYPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OILCHANGEPLAN_GETMYPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OilChangePlanServ_ConfirmRemind({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        confirmRemind(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OILCHANGEPLAN_CONFIRMREMIND_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OILCHANGEPLAN_CONFIRMREMIND_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_OilChangePlan_AddObjResult: state => {
      return state.state_OilChangePlan_AddObjResult;
    },
    get_OilChangePlan_GetPageResult: state => {
      return state.state_OilChangePlan_GetPageResult;
    },
    get_OilChangePlan_GetDetailResult: state => {
      return state.state_OilChangePlan_GetDetailResult;
    },
    get_OilChangePlan_ModifyObjResult: state => {
      return state.state_OilChangePlan_ModifyObjResult;
    },
    get_OilChangePlan_DeleteObjResult: state => {
      return state.state_OilChangePlan_DeleteObjResult;
    },
    get_OilChangePlan_GetMyPageResult: state => {
      return state.state_OilChangePlan_GetMyPageResult;
    },
    get_OilChangePlan_ConfirmRemindResult: state => {
      return state.state_OilChangePlan_ConfirmRemindResult;
    },
  }
}